import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('@/pages/home/page'));
const DemoPage = lazy(() => import('@/pages/demo/page'));
const PrivacyPolicyPage = lazy(() => import('@/pages/privacy-policy/page'));
const NotFound = lazy(() => import('@/pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/demande-demo',
    element: <DemoPage />,
  },
  {
    path: '/politique-de-confidentialite',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
